import { ISlideshow } from 'old-store/types/slideshowsCollections';
import { createAction } from 'redux-act';

export const fetchSlideshows = createAction('FETCH_SLIDESHOW');
export const fetchSlideshowsSuccess = createAction<ISlideshow[]>('FETCH_SLIDESHOW_SUCCESS');
